// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"91619109b0f1fec8","3451":"c3ff4ddae3923660","4157":"982a2a40a0080442","5405":"e527e5ae976e5785"}[chunkId] + ".css";
};